import React from 'react';
import { Link } from 'react-router-dom';

// Import translation
import i18n from 'i18next';

export const createColumns = (handleSelectItem, isReadOnly) => [
	{
		Header: i18n.t('banners:table_columns.title'),
		accessor: 'title',
		Cell: ({
			row: {
				_original: { uuid, title }
			}
		}) => <Link to={`/panel/banners/edit/${uuid}/metadata`}>{title}</Link>
	},
	{
		Header: i18n.t('banners:table_columns.group'),
		accessor: 'group'
	},
	{
		Header: i18n.t('banners:table_columns.url_pc'),
		accessor: 'url_pc'
	},
	{
		Header: i18n.t('banners:table_columns.url_mobile'),
		accessor: 'url_mobile',
		Cell: ({
			row: {
				_original: { url_mobile }
			}
		}) => <span>{url_mobile}</span>
	},
	{
		Header: i18n.t('banners:table_columns.updated_at'),
		accessor: 'updated_at'
	},
	{
		Header: i18n.t('common:table_columns.delete'),
		accessor: 'delete',
		width: 60,
		className: 'text-center',
		sortable: false,
		Cell: ({
			row: {
				_original: { uuid }
			}
		}) =>
			!isReadOnly && (
				<button
					onClick={() => handleSelectItem(uuid)}
					className="btn btn-xs btn-primary"
				>
					<i className="fa fa-trash" />
				</button>
			)
	}
];
